import { createContext, useContext } from "react";

import { AssemblyWithChildren, QuoteRequestLineDto } from "shared";

export type AssembliesContextType = {
  assemblies: AssemblyWithChildren<QuoteRequestLineDto>[];
  activeAssembliesByBatch: Record<string, string>;
  isFetching: boolean;
  selectedQuoteRequestLines: QuoteRequestLineDto[];
  setSelectedQuoteRequestLines: React.Dispatch<React.SetStateAction<QuoteRequestLineDto[]>>;
  setActiveAssemblyForBatch: (partId: string, assemblyId: string) => void;
  resetActiveAssembliesForBatch: (partId: string) => void;
};

const AssembliesContext = createContext<AssembliesContextType>({
  assemblies: [],
  activeAssembliesByBatch: {},
  isFetching: false,
  selectedQuoteRequestLines: [],
  setSelectedQuoteRequestLines: () => {},
  setActiveAssemblyForBatch: () => {},
  resetActiveAssembliesForBatch: () => {},
});

export const useAssembliesContext = () => useContext(AssembliesContext);

export const AssembliesProvider = AssembliesContext.Provider;
